import { createActionType } from 'app/lib/actionTypes';

export const FORM_DATA_LOAD = createActionType('FORM_DATA_LOAD');
export const DATA_LOAD_REQUEST = createActionType('DATA_LOAD_REQUEST');
export const DATA_LOAD_DONE = createActionType('DATA_LOAD_DONE');
export const DATA_LOAD_SUCCESS = createActionType('DATA_LOAD_SUCCESS');
export const DATA_LOAD_ERROR = createActionType('DATA_LOAD_ERROR');

export const HTTP_ERROR_401 = createActionType('HTTP_ERROR_401');

export const FLASH_MESSAGE = {
    SET: createActionType('FLASH_MESSAGE_SET'),
    REMOVE: createActionType('FLASH_MESSAGE_REMOVE')
};